import {createSvgIcon} from '../create-svg-icon';

export const ChevronDownIcon = createSvgIcon(
  <path d="M7 10l5 5 5-5z" />,
  'ChevronDown'
);